function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";

  // Update VIEW ALL button link based on selected tab
  updateViewAllButtonLink(sectionId, tabName);
}

// Function to update VIEW ALL button link based on selected tab
function updateViewAllButtonLink(sectionId, tabName) {
  // Get the section element
  const section = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (!section) return;

  // Get the VIEW ALL button in this section
  const viewAllButton = section.querySelector('.section__head--buttons .button');
  if (!viewAllButton) return;

  // Get the clicked tab button to extract the collection link
  const clickedTabButton = document.querySelector(`[onclick*="${tabName}"]`);
  if (!clickedTabButton) return;

  // Get the collection link from the data attribute
  const collectionLink = clickedTabButton.getAttribute('data-collection-link');
  if (collectionLink) {
    viewAllButton.href = collectionLink;
  }
}

// show the first tabs by default on load - data-default-open
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
  
  // Also update the VIEW ALL button link for the default tab
  const sectionId = el.getAttribute('onclick').match(/'([^']+)'/)[1];
  const tabName = el.getAttribute('onclick').match(/'([^']+)'/)[2];
  updateViewAllButtonLink(sectionId, tabName);
});

window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
    
    // Also update the VIEW ALL button link for the default tab
    const sectionId = el.getAttribute('onclick').match(/'([^']+)'/)[1];
    const tabName = el.getAttribute('onclick').match(/'([^']+)'/)[2];
    updateViewAllButtonLink(sectionId, tabName);
  });
});
